import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import EnhancedTable from './EnhancedTable';
import TableActionMenu from './TableActionMenu';
import ScheduleDataAccess from '../services/scheduleDataAccess';
import Auth from '../services/auth';
import Snackbar from '@material-ui/core/Snackbar';
import PubSub from 'pubsub-js';
import qs from 'qs';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Typography } from '@material-ui/core';
import ScheduleAdd from './ScheduleAdd';
import SettingsDataAccess from '../services/settingsDataAccess';

const dataAccess = new ScheduleDataAccess();
const settingsDataAccess = new SettingsDataAccess();
const auth = new Auth();


const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing(3),
    })
});



class Schedule extends Component {
    displayName = Schedule.name

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            statusFilters: [],
            isLoading: false,
            openSnack: false,
            snackMessage: "",
            openProcedureDialog: false,
            activeProcedureFilter: { Account: '', Id: 0, Description: '' },
            includeFilteredItems: false,
            showHiddenItems: false,
            showAddDialog: false,
            openScheduleRemoveDialog: false,
            itemToDelete: {},
            removeScheduleItem: false
        };
    }

    componentWillMount() {

        var initialStatus = ["New", "NeedsDictation", "InProgress", "CompletedWithQuestions", "Completed"];

        if (this.props.location.search) {

            var query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

            if (query.status && query.status.length > 0) {
                initialStatus = query.status;
            }
        }

        this.setState({
            statusFilters: initialStatus
        }, () => {
            this.loadScheduleData();
        });
        // This is where we subscribe this class to the 'GET FILES' subscription.
        // once a publish event for 'GET FILES' has been fired, FileList.subscriber() will be triggered.
        this.token = PubSub.subscribe('AccountChanged', this.accountChanged.bind(this));
    }
    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }

    loadScheduleData() {
        var self = this;
        self.setState({ isLoading: true });
        dataAccess.getAll(this.state.statusFilters, this.state.includeFilteredItems, this.state.showHiddenItems).then(function (reportData) {
            settingsDataAccess.getAccountSettingsBySettingsName("RemoveScheduleItem").then((result) => {
                let removeScheduleItem = result && result.data && result.data.Id > 0 && result.data.SettingValue == "1";
                self.setState({ data: reportData, isLoading: false, removeScheduleItem: removeScheduleItem });
            })
        });


    }

    handleSnackClose = () => {
        this.setState({ openSnack: false, snackMessage: "" });
    };

    accountChanged(msg, data) {
        this.loadScheduleData();
    }

    onAddScheduleClick = () => {

        let showDialog = !this.state.showAddDialog;
        this.setState({ showAddDialog: showDialog });
    }

    onUploadClick = () => {
        this.setState({showUploadDialog: !this.state.showUploadDialog})
    }
    

    onFilterChanged = (value, filterName) => {

        if (filterName === "toDate") {
            auth.setToDate(value);
            this.loadScheduleData();
        }

        if (filterName === "fromDate") {
            auth.setFromDate(value);
            this.loadScheduleData();
        }

        if (filterName === "status") {


            this.setState({
                statusFilters: value
            }, () => {

                this.loadScheduleData();
                this.props.history.replace(`/schedule/?${qs.stringify({ status: this.state.statusFilters })}`);
            });


        }




    }
    onActionMapped(action, item) {

        if (action.name === 'hide') {
            return (auth.isInRole('FacilityAdmin') || auth.isInRole("Admin")) && item.Status <= 1 && item.ProcedureId > 0;
        }

        if (action.name === 'hideItem' || action.name === 'unhideItem') {
            return auth.isInRole('FacilityAdmin') || auth.isInRole("Admin");
        }

        return true;
    }

    onActionSelected(e, action, item) {

        switch (action) {
            case 'remove':
                this.setState({ openScheduleRemoveDialog: true, itemToDelete: item });
                break;
            case 'details':
                this.props.history.push(`/scheduleDetails/${item.Account}/${item.Id}`);
                break;
            case 'hide':
                this.setState({ openProcedureDialog: true, activeProcedureFilter: { Account: item.Account, Id: item.ProcedureId, Description: item.Procedure }, });
                break;
            case 'hideItem':
                this.onSaveScheduleItemVisibility(item, true);
                break;
            case 'unhideItem':
                this.onSaveScheduleItemVisibility(item, false);
                break;
            default:
                console.warn(
                    'Action::Unknown action name. Valid types are \'details\' and \'hide\'.',
                    action);

        }
    }
    onSaveScheduleItemVisibility = (item, isHidden) => {

        var self = this;

        dataAccess.saveScheduleItemVisibility({
            Account: item.Account,
            Id: item.Id,
            IsHidden: isHidden
        }).then(() => {
            self.setState({
                openSnack: true,
                snackMessage: isHidden ? 'Appointment hidden' : 'Appointment unhidden'
            });
            self.loadScheduleData();
        }).catch(() => {
            self.setState({
                openSnack: true,
                snackMessage: isHidden ? 'Error hiding appointment' : 'Error unhiding appointment'
            });
        });
    }


    onCancelScheduleRemoveDialog = () => {
        this.setState({ openScheduleRemoveDialog: false, itemToDelete: null });
    }

    onCancelProcedureDialog = () => {
        this.setState({ openProcedureDialog: false, activeProcedureFilter: { Account: '', Id: 0, Description: '' } });
    }

    onCancelScheduleAdd = () => {
        this.setState({ showAddDialog: false });
    }

    onSaveScheduleComplete = () => {
        this.setState({ openSnack: true, snackMessage: 'Appointment added', showAddDialog: false });

        this.loadScheduleData();
    }

    onSaveProcedureFilter = () => {

        var self = this;

        dataAccess.saveProcedureFilter({ Account: this.state.activeProcedureFilter.Account, ProcedureId: this.state.activeProcedureFilter.Id, IsFiltered: true }).then((data) => {

            self.setState({ openSnack: true, snackMessage: 'Saved procedure filter', openProcedureDialog: false, activeProcedureFilter: { Account: '', Id: 0, Description: '' } });
            self.loadScheduleData();
        });

    }

    removeScheduelItem = () => {

        var self = this;
        dataAccess.removeSchedule(this.state.itemToDelete).then((data) => {
            self.setState({ openSnack: true, snackMessage: 'Appointment removed', openScheduleRemoveDialog: false, itemToDelete: null });
            self.loadScheduleData();
        }).catch(err => {
            self.setState({ openSnack: true, snackMessage: 'Error removing appointment', openScheduleRemoveDialog: false, itemToDelete: null });
        });
    }

    renderActions(item) {

        let actionsList = [
            {
                type: 'option',
                description: item.IsHidden ? 'Unhide this item' : 'Hide this item',
                name: item.IsHidden ? 'unhideItem' : 'hideItem'
            },
            { type: 'option', description: 'Hide items with this procedure', name: 'hide' },
            { type: 'divider' },
            { type: 'option', description: 'Details', name: 'details' }];

        if (this.state.removeScheduleItem) {
            actionsList.push({ type: 'divider' });
            actionsList.push({ type: 'option', description: 'Remove', name: 'remove' });
        }

        return (
            <TableActionMenu actions={actionsList}
            item={item}
            onActionMapped={this.onActionMapped}
            onActionSelected={(e, action, item) => this.onActionSelected(e, action, item)}
        />);
    }

    toggleFilteredItems = () => {

        var self = this;
        var selectedState = !this.state.includeFilteredItems;
        this.setState({ includeFilteredItems: selectedState }, () => {
            self.loadScheduleData();
        });
    }

    toggleHiddenItems = () => {

        var self = this;
        var selectedState = !this.state.showHiddenItems;
        this.setState({ showHiddenItems: selectedState }, () => {
            self.loadScheduleData();
        });
    }

    rendertableFilterToggle = () => {


        const isAdmin =
            auth.isInRole('FacilityAdmin') || auth.isInRole('Admin');

        return (<div>
            {isAdmin && ( <FormControlLabel
                control={<Switch size="small" checked={this.state.showHiddenItems} onChange={this.toggleHiddenItems} color="primary" />}
                label={<Typography variant="subtitle2">Include hidden items</Typography>}

            />)}
            <FormControlLabel
                control={<Switch size="small" checked={this.state.includeFilteredItems} onChange={this.toggleFilteredItems} />}
                label={<Typography variant="subtitle2">Include procedure filtered visits</Typography>}

            />
            

        </div>
        );
    }

    render() {


        const { statusFilters, openSnack, snackMessage } = this.state;
        const columnData = [
            { id: 'PatientId', numeric: false, disablePadding: false, label: 'Patient ID', link: true, linkPath: 'scheduleDetails', linkParams: ['Account', 'Id'], filter: "textSearch", renderActions: this.renderActions.bind(this), maxWidth: 75 },
            { id: 'DateOfService', numeric: false, disablePadding: false, label: 'Date Of Service', link: false, filter: "dateSearch" },
            { id: 'PatientFirstName', numeric: false, disablePadding: false, label: 'Patient First Name', link: false, filter: "textSearch" },
            { id: 'PatientLastName', numeric: false, disablePadding: false, label: 'Patient Last Name', link: false, filter: "textSearch" },
            { id: 'Physician', numeric: false, disablePadding: false, label: 'Physician', link: false, filter: "choice", maxWidth: 160 },
            { id: 'Procedure', numeric: false, disablePadding: false, label: 'Procedure', link: false, filter: "textSearch", maxWidth: 200 },
            { id: 'DateOfBirth', numeric: false, disablePadding: false, label: 'Date Of Birth', link: false, filter: "dateSearch" },
        ];


        return (
            <div>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={openSnack}
                    autoHideDuration={3000}
                    onClose={this.handleSnackClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{snackMessage}</span>}
                />
                <ScheduleAdd open={this.state.showAddDialog}
                    onCancel={this.onCancelScheduleAdd}
                    onSaveComplete={this.onSaveScheduleComplete}
                ></ScheduleAdd>
                <Dialog onClose={this.onCancelProcedureDialog} open={this.state.openProcedureDialog} aria-labelledby="simple-dialog-title">
                    <DialogTitle id="simple-dialog-title">Create Procedure Filter</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Always hide visits with this procedure <strong>'{this.state.activeProcedureFilter.Description}'</strong>?
                            <br />
                            <Typography variant="caption">Note: Visits will also be hidden from the Surgical Notes mobile application</Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onSaveProcedureFilter} variant="contained" color="secondary">
                            OK
                        </Button>
                        <Button onClick={this.onCancelProcedureDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog onClose={this.onCancelScheduleRemoveDialog} open={this.state.openScheduleRemoveDialog} aria-labelledby="simple-dialog-title">
                    <DialogTitle id="simple-dialog-title">Remove Schedule Item</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to remove this schedule item?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.removeScheduelItem} variant="contained" color="secondary">
                            OK
                        </Button>
                        <Button onClick={this.onCancelScheduleRemoveDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <EnhancedTable columnData={columnData}
                    rowData={this.state.data} tableTitle={'Schedule'}
                    defaultStartDate={auth.getFromDate()}
                    isLoading={this.state.isLoading}
                    defaultEndDate={auth.getToDate()}
                    onGlobalFilterChanged={this.onFilterChanged}
                    includeActions={false}
                    showAddButton={auth.isInRole('FacilityAdmin')}
                    showUploadButton={auth.isInRole('FacilityAdmin')}
                    onAddClick={this.onAddScheduleClick}
                    onUploadClick={this.onUploadClick }
                    orderBy={'DateOfService'}
                    orderDirection={'desc'}
                    showActions
                    tableFilterToggle={this.rendertableFilterToggle}
                    rowActions={[
                        "Hide items like this...",
                        "Details"
                    ]}
                    globalSelectFilters={[
                        { label: 'New', value: 'New', style: { borderLeft: '10px solid #FFFFFF' } },
                        { label: 'Needs Dictation', value: 'NeedsDictation', style: { borderLeft: '10px solid #F40013' } },
                        { label: 'In Progress', value: 'InProgress', style: { borderLeft: '10px solid #F5F545' } },
                        { label: 'Completed With Questions', value: 'CompletedWithQuestions', style: { borderLeft: '10px solid #31a7ff' } },
                        { label: 'Completed', value: 'Completed', style: { borderLeft: '10px solid #17c92c' } },
                        { label: 'Signed', value: 'Signed', style: { borderLeft: '10px solid #333333' } }
                    ]}
                    defaultFilters={statusFilters} />
            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(Schedule);



// WEBPACK FOOTER //
// ./src/components/Schedule.js